<template>
  <div class="edit-mapping">
    <b-modal ref="mapEditModalRef" :title="modalTitle()" @hide="cancelUpdateMapping" @shown="focusOnInput" hide-header-close centered>
      <b-container fluid>
        <div v-if="this.element.el_type === 'Shape'">
          <b-row class="mb-3">
            <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.KEY') }}</b-col>
            <b-col>
              <b-form-input type="text" v-model="element.key" placeholder="Key" ref="updateFieldKey"></b-form-input>
              <div v-if="element.key && !isKeyUnique" style="color:red">Key must be unique.</div>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.DATA_TYPE') }}</b-col>
            <b-col>
              <b-form-select :plain="true" :options="listTypes" v-model="element.type" placeholder="Mapping Type" @input="handleRequired()">
              </b-form-select>
            </b-col>
          </b-row>
          <b-row v-if="element.type == 'date'" class="mb-3">
            <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.DATE_CATEGORY') }}</b-col>
            <b-col>
              <b-form-select :plain="true" :options="dateCategoryList" v-model="element.date_category" placeholder="Select Date Category">
              </b-form-select>
            </b-col>
          </b-row>
          <b-row v-if="element.type == 'date'" class="mb-3">
            <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.DATE_FORMAT') }}</b-col>
            <b-col>
              <b-form-select :plain="true" :options="dateFormatList" v-model="element.dateFormat" placeholder="Select Date Format">
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.MAPPING_CATEGORY') }}</b-col>
            <b-col>
              <b-form-select :plain="true" :options="mappingCategories" v-model="element.category" placeholder="Mapping Category">
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.ORDER_OF_OCCUR') }}</b-col>
            <b-col>
              <b-form-select :plain="true" :options="orderOptions" v-model="element.order" placeholder="Mapping Order">
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-3" v-if="canExtract">
            <b-col cols="3">{{ $t('TEMPLATE.EXT') }}</b-col>
            <b-col>
              <b-form-radio-group>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="extEditYes" class="custom-control-input" :value="true" v-model="element.extract">
                  <label class="custom-control-label" for="extEditYes">{{ $t('COMMON.YES') }}</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="extEditNo" class="custom-control-input" :value="false" v-model="element.extract">
                  <label class="custom-control-label" for="extEditNo">{{ $t('COMMON.NO') }}</label>
                </div>
              </b-form-radio-group>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3">{{ $t('TEMPLATE.EXT_BY_WORDS') }}</b-col>
            <b-col>
              <b-form-radio-group>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="extractByWordEditYes" class="custom-control-input" :value="true" v-model="element.extract_by_words">
                  <label class="custom-control-label" for="extractByWordEditYes">{{ $t('COMMON.YES') }}</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="extractByWordEditNo" class="custom-control-input" :value="false" v-model="element.extract_by_words">
                  <label class="custom-control-label" for="extractByWordEditNo">{{ $t('COMMON.NO') }}</label>
                </div>
              </b-form-radio-group>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3">{{ $t('TEMPLATE.REDACT_FIELD') }}</b-col>
            <b-col>
              <b-form-radio-group>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="redactFieldsYes" class="custom-control-input" :value="true" v-model="element.redact_field">
                  <label class="custom-control-label" for="redactFieldsYes">{{ $t('COMMON.YES') }}</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="redactFieldsNo" class="custom-control-input" :value="false" v-model="element.redact_field">
                  <label class="custom-control-label" for="redactFieldsNo">{{ $t('COMMON.NO') }}</label>
                </div>
              </b-form-radio-group>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3">{{ $t('TEMPLATE.SHOW_FIELD') }}</b-col>
            <b-col>
              <b-form-radio-group>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="showFieldTrue" class="custom-control-input" :value="true" v-model="element.show_field">
                  <label class="custom-control-label" for="showFieldTrue">{{ $t('COMMON.YES') }}</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="showFieldFalse" class="custom-control-input" :value="false" v-model="element.show_field">
                  <label class="custom-control-label" for="showFieldFalse">{{ $t('COMMON.NO') }}</label>
                </div>
              </b-form-radio-group>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.CASE') }}</b-col>
            <b-col>
              <b-form-select :plain="true" :options="caseCategories" v-model="element.case" placeholder="Mapping Case">
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3">{{ $t('TEMPLATE.SENS_DATA') }}</b-col>
            <b-col>
              <b-form-radio-group>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="editSensitiveDataYes" class="custom-control-input" :value="true" v-model="element.sensitive_data">
                  <label class="custom-control-label" for="editSensitiveDataYes">{{ $t('COMMON.YES') }}</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="editSensitiveDataNo" class="custom-control-input" :value="false" v-model="element.sensitive_data">
                  <label class="custom-control-label" for="editSensitiveDataNo">{{ $t('COMMON.NO') }}</label>
                </div>
              </b-form-radio-group>
            </b-col>
          </b-row>
          <b-row class="mb-3" v-if="canShowRequired">
            <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.REQ') }}</b-col>
            <b-col>
              <b-form-radio-group>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="requiredEditYes" class="custom-control-input" :value="true" v-model="element.required">
                  <label class="custom-control-label" for="requiredEditYes">{{ $t('COMMON.YES') }}</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="requiredEditNo" class="custom-control-input" :value="false" v-model="element.required">
                  <label class="custom-control-label" for="requiredEditNo">{{ $t('COMMON.NO') }}</label>
                </div>
              </b-form-radio-group>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.ALIAS') }}</b-col>
            <b-col>
              <multiselect v-model="selectedAliasData" tag-placeholder="Add this as Alias" placeholder="Search or add a tag" :options="aliasOptions" :multiple="true" :taggable="true" @tag="addTag"></multiselect>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3" class="modal-label">{{ $t('COMMON.DESCRIPTION') }}</b-col>
            <b-col>
              <b-form-textarea v-model="element.description" :placeholder="$t('COMMON.DESCRIPTION')">
              </b-form-textarea>
            </b-col>
          </b-row>
        </div>
        <div v-else-if="element.type !== 'npi'">
          <b-row class="mb-3">
            <b-col cols="3">{{ $t('COMMON.NAME') }}</b-col>
            <b-col>
              <b-form-input type="text" v-model="element.key" :placeholder="$t('TEMPLATE.GRP_NAME')" ref="updateFieldKey"></b-form-input>
            </b-col>
            <div v-if="element.key && !isKeyUnique" style="color:red">Key must be unique.</div>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3">{{ $t('TEMPLATE.TYPE') }}</b-col>
            <b-col>
              <b-form-select :plain="true" :options="groupTypes" v-model="element.type" :placeholder="$t('TEMPLATE.GRP_TYPE')" @input="handleRequired()">
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.ORDER_OF_OCCUR') }}</b-col>
            <b-col>
              <b-form-select :plain="true" :options="orderOptions" v-model="element.order" placeholder="Mapping Order">
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-3" v-if="canShowRequired">
            <b-col cols="3">{{ $t('TEMPLATE.REQ') }}</b-col>
            <b-col>
              <b-form-radio-group>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="requiredGrpEditYes" class="custom-control-input" :value="true" v-model="element.required">
                  <label class="custom-control-label" for="requiredGrpEditYes">{{ $t('COMMON.YES') }}</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="requiredGrpEditNo" class="custom-control-input" :value="false" v-model="element.required">
                  <label class="custom-control-label" for="requiredGrpEditNo">{{ $t('COMMON.NO') }}</label>
                </div>
              </b-form-radio-group>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <b-row class="mb-3">
            <b-col cols="3">Name</b-col>
            <b-col>
              <b-form-input type="text" v-model="element.key" placeholder="Group Name" ref="updateFieldKey"></b-form-input>
              <div v-if="element.key && !isKeyUnique" style="color:red">Key must be unique.</div>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3">NPI</b-col>
            <b-col>
              <b-form-select :plain="true" :options="npiFields" @change="npiFieldChanged('npi')" v-model="group.npi" placeholder="NPI" :state="!$v.group.npi.$invalid">
                </b-form-select>
              <b-form-invalid-feedback id="input2LiveFeedback">This is a required field
                </b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3">Prescriber First Name</b-col>
            <b-col>
              <b-form-select :plain="true" :options="npiFields" @change="npiFieldChanged('first_name')" v-model="group.first_name" placeholder="First Name">
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3">Prescriber Last Name</b-col>
            <b-col>
              <b-form-select :plain="true" :options="npiFields" @change="npiFieldChanged('last_name')" v-model="group.last_name" placeholder="Last Name">
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3">Prescriber Name</b-col>
            <b-col>
              <b-form-select :plain="true" :options="npiFields" @change="npiFieldChanged('name')" v-model="group.name" placeholder="Name">
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3">City</b-col>
            <b-col>
              <b-form-select :plain="true" :options="npiFields" @change="npiFieldChanged('city')" v-model="group.city" placeholder="City">
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3">State</b-col>
            <b-col>
              <b-form-select :plain="true" :options="npiFields" @change="npiFieldChanged('state')" v-model="group.state" placeholder="State">
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="3">Zipcode</b-col>
            <b-col>
              <b-form-select :plain="true" :options="npiFields" @change="npiFieldChanged('zipcode')" v-model="group.zipcode" placeholder="ZipCode">
              </b-form-select>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div slot="modal-footer" class="w-100 d-flex justify-content-end">
        <b-btn size="sm" class="float-right" variant="secondary mr-1" :disabled="!isKeyUnique || (element.type == 'date' && !element.dateFormat)" @click="updateMapping">{{ $t('COMMON.UPDATE') }}</b-btn>
        <b-btn size="sm" class="float-right" variant="light" @click="cancelMapping">{{ $t('COMMON.CANCEL') }}</b-btn>
      </div>
    </b-modal>
    <b-modal :title="'Edit Mapping'" hide-header-close centered ok-only ok-variant="secondary" @ok="editDrawing" ref="agnetEditMappingModal">
      <p>You are not permitted to access this. Kindly contact administrator</p>
    </b-modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  components: { Multiselect },
  props: ['mappingsKeys', 'orderOptions', 'showEditMapping', 'canvasElement', 'npiGroups', 'stage'],
  data () {
    return {
      oldGroup: {
        npi_group_name: null,
        npi: null,
        first_name: null,
        last_name: null,
        name: null,
        city: null,
        state: null,
        zipcode: null
      },
      group: {
        npi_group_name: null,
        npi: null,
        first_name: null,
        last_name: null,
        name: null,
        city: null,
        state: null,
        zipcode: null
      },
      element: {
        replacedNpiMappings: [],
        key: null,
        oldKey: null,
        originalKey: null,
        type: null,
        category: null,
        originalOrder: null,
        order: null,
        case: null,
        description: null,
        required: false,
        extract: true,
        extract_by_words: false,
        redact_field: true,
        show_field: true,
        sensitive_data: false,
        key_alias: [],
        path: null,
        el_type: null,
        dateFormat: null,
        date_category: null,
        parentDataType: null,
        parentKey: null
      },
      npiFields: [
        { value: null, text: 'Please select type' }
      ],
      mappingCategories: [
        { value: 'default', text: this.$t('DATA_TYPE.DEFAULT') },
        { value: 'block', text: this.$t('DATA_TYPE.BLOCK') }
      ],
      caseCategories: [
        { value: null, text: this.$t('TEMPLATE.SELECT_CASE') },
        { value: 'capitalize', text: this.$t('DATA_TYPE.CAPITALIZE') },
        { value: 'upper_case', text: this.$t('DATA_TYPE.UPPER_CASE') },
        { value: 'lower_case', text: this.$t('DATA_TYPE.LOWER_CASE') },
        { value: 'titleize', text: this.$t('DATA_TYPE.TITLEIZE') }
      ],
      listTypes: [
        { value: null, text: this.$t('TEMPLATE.SELECT_DATA_TYPE') },
        { value: 'alpha', text: this.$t('DATA_TYPE.ALPHA') },
        { value: 'alphanumeric', text: this.$t('DATA_TYPE.ALPHANUM') },
        { value: 'alphanumeric_with_space', text: this.$t('DATA_TYPE.ALPHANUMSPC') },
        { value: 'address_without_po_box', text: 'Address (No PO Box)' },
        { value: 'numeric_with_decimal', text: this.$t('DATA_TYPE.NUMERICDEC') },
        { value: 'checkbox', text: this.$t('DATA_TYPE.CHECKBOX') },
        { value: 'city', text: this.$t('DATA_TYPE.CITY') },
        { value: 'cod', text: 'COD' },
        { value: 'date', text: this.$t('DATA_TYPE.DATE') },
        { value: 'email', text: 'Email' },
        { value: 'fax', text: 'Fax' },
        { value: 'npi', text: 'NPI' },
        { value: 'numeric', text: this.$t('DATA_TYPE.NUMERIC') },
        { value: 'phone', text: 'Phone' },
        { value: 'signature', text: 'Signature' },
        { value: 'state', text: this.$t('DATA_TYPE.STATE') },
        { value: 'text', text: this.$t('DATA_TYPE.TEXT') },
        { value: 'zip', text: 'ZIP' }
      ],
      dateFormatList: [
        { value: null, text: this.$t('TEMPLATE.SELECT_DATE_FORMAT') },
        { value: 'dd mm yyyy', text: 'dd mm yyyy' },
        { value: 'mm dd yyyy', text: 'mm dd yyyy' },
        { value: 'yyyy mm dd', text: 'yyyy mm dd' },
        { value: 'yyyy dd mm', text: 'yyyy dd mm' }
      ],
      dateCategoryList: [
        { value: 'normal_date', text: 'Normal Date' },
        { value: 'dob', text: 'DOB' },
        // { value: 'expire_date', text: 'Expiration Date' },
        { value: 'future_date', text: 'Future Date' }
      ],
      groupTypes: [
        { value: null, text: 'Please select type' },
        { value: 'npi', text: this.$t('DATA_TYPE.NPI') },
        { value: 'logical', text: this.$t('DATA_TYPE.LOGICAL') },
        { value: 'name', text: this.$t('DATA_TYPE.NAME') },
        { value: 'combine_data', text: this.$t('DATA_TYPE.COMBINE_DATA') },
        { value: 'checkbox_text', text: this.$t('DATA_TYPE.CHECKBOX_TEXT') },
        { value: 'single_select', text: this.$t('DATA_TYPE.EITHER') },
        { value: 'multi_select', text: this.$t('DATA_TYPE.MULTI_CHOICE') },
        { value: 'table_header', text: this.$t('DATA_TYPE.TABLE_HEADER') },
        { value: 'table_entry', text: this.$t('DATA_TYPE.TABLE_ENTRY') },
        { value: 'table_row', text: this.$t('DATA_TYPE.TABLE_ROW') },
        { value: 'table_column', text: this.$t('DATA_TYPE.TABLE_COLUMN') },
        { value: 'section', text: this.$t('DATA_TYPE.SECTION') }
      ],
      aliasOptions: [],
      selectedAliasData: [],
      requiredNAtypes: [ undefined, null, 'npi', 'logical', 'combine_data', 'checkbox_text', 'table_row', 'table_column', 'table_header', 'table_entry' ],
      canShowRequired: false,
      canExtract: true,
      requiredNA: false,
      isKeyUnique: true,
      isMappingNpiGroup: false,
      isMappingPartOfNpiGroup: false
    }
  },
  validations: {
    group: {
      npi: {
        required
      }
    }
  },
  computed: {
    ...mapGetters(['isAdminRole'])
  },
  watch: {
    'element.key': function (newLabel, oldLabel) {
      // this.element.oldKey is null at data initialization only
      if (newLabel) {
        if (this.isMappingNpiGroup || this.isMappingPartOfNpiGroup) {
          for (var key in this.group) {
            if (this.group[key] === this.element.oldKey) {
              this.group[key] = this.element.key
              this.oldGroup[key] = this.element.key
              this.element.oldKey = this.element.key
            }
          }
        }
        this.isKeyUnique = this.checkIfKeyUnique()
      } else {
        this.isKeyUnique = false
      }
    },
    showEditMapping: function () {
      if (this.showEditMapping) {
        if (this.isAdminRole) {
          let elemAttrs = this.canvasElement.attrs
          let parentAttrs = this.canvasElement.parent.attrs
          this.element = {
            replacedNpiMappings: [],
            key: elemAttrs.key,
            oldKey: elemAttrs.key,
            originalKey: elemAttrs.key,
            originalOrder: elemAttrs.order,
            type: elemAttrs.dataType,
            category: elemAttrs.category,
            order: elemAttrs.order,
            case: elemAttrs.case,
            description: elemAttrs.description,
            required: elemAttrs.required,
            extract: elemAttrs.extract,
            extract_by_words: elemAttrs.extract_by_words,
            redact_field: elemAttrs.redact_field,
            show_field: elemAttrs.show_field,
            sensitive_data: elemAttrs.sensitive_data,
            key_alias: elemAttrs.key_alias || [],
            path: elemAttrs.path,
            el_type: this.canvasElement.nodeType,
            dateFormat: elemAttrs.dateFormat,
            date_category: elemAttrs.date_category,
            parentDataType: elemAttrs.parentDataType,
            parentKey: elemAttrs.parentKey
          }
          this.selectedAliasData = JSON.parse(JSON.stringify(this.element.key_alias))
          this.aliasOptions = JSON.parse(JSON.stringify(this.element.key_alias))
          this.isMappingNpiGroup = (elemAttrs.dataType === 'npi' && elemAttrs.map_type === 'group')
          this.isMappingPartOfNpiGroup = (parentAttrs.dataType === 'npi' && parentAttrs.map_type === 'group')
          this.npiFields = [{ value: null, text: 'Please select type' }]
          // if mapping being edited is npi group
          if (this.isMappingNpiGroup) {
            var npiGroup = this.npiGroups.filter((mapping) => {
              return ((mapping['npi_group_name'] === elemAttrs.key) || (mapping['npi_group_name'] === parentAttrs.key))
            })
            if (npiGroup && npiGroup.length > 0) {
              npiGroup = npiGroup[0]
              this.group = {
                npi_group_name: npiGroup.npi_group_name,
                npi: npiGroup.npi,
                first_name: npiGroup.first_name,
                last_name: npiGroup.last_name,
                name: npiGroup.name,
                city: npiGroup.city,
                state: npiGroup.state,
                zipcode: npiGroup.zipcode
              }
              this.oldGroup = {
                npi_group_name: npiGroup.npi_group_name,
                npi: npiGroup.npi,
                first_name: npiGroup.first_name,
                last_name: npiGroup.last_name,
                name: npiGroup.name,
                city: npiGroup.city,
                state: npiGroup.state,
                zipcode: npiGroup.zipcode
              }
              this.insertGroupFields()
            }
          }
          this.$refs.mapEditModalRef.show()
        } else {
          this.$refs.agnetEditMappingModal.show()
        }
      } else {
        this.$refs.mapEditModalRef.hide()
      }
    }
  },
  methods: {
    addTag (newTag) {
      this.selectedAliasData.push(newTag)
      this.aliasOptions.push(newTag)
    },
    npiFieldChanged (type) {
      if (this.oldGroup[type]) {
        this.element.replacedNpiMappings.push(this.oldGroup[type])
      }
    },
    editDrawing () {
      this.$refs.agnetEditMappingModal.hide()
      this.$emit('cancelled')
    },
    checkIfKeyUnique () {
      let normalisedOriginalKey = this.element.originalKey.toLowerCase().replace(/\s/g, '')
      let normalisedNewKey = this.element.key.toLowerCase().replace(/\s/g, '')
      if (normalisedOriginalKey !== normalisedNewKey) {
        return (this.mappingsKeys.indexOf(normalisedNewKey) === -1)
      } else {
        return true
      }
    },
    insertGroupFields () {
      var npiFields = []
      this.stage.find('Rect').forEach((shape) => {
        let shapeAttrs = shape.attrs
        if (shapeAttrs.edit_type === 'created') {
          if (!shapeAttrs.parentDataType || shapeAttrs.parentKey === this.canvasElement.attrs.key) {
            npiFields.push({value: shapeAttrs.key, text: shapeAttrs.key})
          }
        }
      })
      this.npiFields = this.npiFields.slice().concat(npiFields)
    },
    modalTitle () {
      return this.element.el_type === 'Shape' ? this.$t('TEMPLATE.UPDATE_MAP') : this.$t('TEMPLATE.UPDATE_GRP')
    },
    focusOnInput () {
      this.$refs.updateFieldKey.focus()
    },
    updateMapping () {
      if (this.requiredNA === true) this.element.required = false
      this.element.key_alias = this.selectedAliasData
      this.$emit('updated', this.element, this.group, this.oldGroup)
    },
    cancelMapping () {
      this.$refs.mapEditModalRef.hide()
      this.$emit('cancelled')
    },
    cancelUpdateMapping () {
      this.$emit('cancelled')
    },
    checkIfElementPartOfSelectGroup (element) {
      let parentNodeType = this.canvasElement.parent.nodeType
      let parentDataType = this.canvasElement.parent.attrs.dataType
      let isElementPartOfSelectGroup = false
      if (parentNodeType === 'Group') {
        if (parentDataType === 'single_select' || parentDataType === 'multi_select') {
          isElementPartOfSelectGroup = true
        }
      }
      return isElementPartOfSelectGroup
    },
    handleRequired () {
      // selectGroup = either single_select or multi_select group
      let elementType = this.element.type
      this.element.dateFormat = this.element.type === 'date' ? this.element.dateFormat : null
      this.element.date_category = this.element.type === 'date' ? this.element.date_category : null
      let isElementPartOfSelectGroup = this.checkIfElementPartOfSelectGroup(this.element)

      if (elementType === 'checkbox' && isElementPartOfSelectGroup) {
        this.requiredNA = false
        this.canShowRequired = false
      } else if (elementType === 'npi' && this.element.el_type === 'Shape') {
        this.requiredNA = false
        this.canShowRequired = true
      } else if (this.requiredNAtypes.includes(this.element.type)) {
        this.requiredNA = true
        this.canShowRequired = false
      } else {
        this.requiredNA = false
        this.canShowRequired = true
        this.canExtract = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/editMapping.vue